import { userService } from "./userService";

const API_URL = process.env.REACT_APP_API_URL;

export const dashboardService = {
  // =============================
  // ===== Dashboard Summary =====
  // =============================
  async getSummary(userId, dateRange = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (dateRange.startDate)
        queryParams.append("startDate", dateRange.startDate);
      if (dateRange.endDate) queryParams.append("endDate", dateRange.endDate);

      const url = `${API_URL}/api/dashboard/summary${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;

      // First attempt
      let response = await fetch(url, {
        headers: userService._getAuthHeaders(),
      });

      // If token expired → refresh + retry
      if (response.status === 401) {
        const newToken = await userService.refreshAccessToken();
        if (newToken) {
          response = await fetch(url, {
            headers: userService._getAuthHeaders(),
          });
        } else {
          throw new Error("Session expired. Please log in again.");
        }
      }

      if (!response.ok) throw new Error("Failed to fetch dashboard summary");
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error("Error fetching dashboard summary:", error);
      return {
        pendingDebt: 0,
        totalAmount: 0,
        totalRecovered: 0,
        resolvedCount: 0,
        totalInvoiceRevenue: 0,
      };
    }
  },

  // =============================
  // ===== Dashboard Entries =====
  // =============================
  async getEntries(userId, dateRange = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (dateRange.startDate)
        queryParams.append("startDate", dateRange.startDate);
      if (dateRange.endDate) queryParams.append("endDate", dateRange.endDate);

      const url = `${API_URL}/api/dashboard/entries${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;

      let response = await fetch(url, {
        headers: userService._getAuthHeaders(),
      });

      if (response.status === 401) {
        const newToken = await userService.refreshAccessToken();
        if (newToken) {
          response = await fetch(url, {
            headers: userService._getAuthHeaders(),
          });
        } else {
          throw new Error("Session expired. Please log in again.");
        }
      }

      if (!response.ok) throw new Error("Failed to fetch dashboard entries");
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error("Error fetching dashboard entries:", error);
      return { lbaEntries: [], lpdEntries: [], lawFirmEntries: [] };
    }
  },

  // =============================
  // ===== Summary for All Periods =====
  // =============================
  async getSummaryForAllPeriods(userId) {
    try {
      const url = `${API_URL}/api/dashboard/summary-periods`;
      let response = await fetch(url, {
        headers: userService._getAuthHeaders(),
      });

      if (response.status === 401) {
        const newToken = await userService.refreshAccessToken();
        if (newToken) {
          response = await fetch(url, {
            headers: userService._getAuthHeaders(),
          });
        } else {
          throw new Error("Session expired. Please log in again.");
        }
      }

      if (!response.ok) throw new Error("Failed to fetch period summaries");
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error("Error fetching period summaries:", error);
      return {
        "24hours": {
          pendingDebt: 0,
          totalAmount: 0,
          totalRecovered: 0,
          resolvedCount: 0,
          totalInvoiceRevenue: 0,
        },
        "7days": {
          pendingDebt: 0,
          totalAmount: 0,
          totalRecovered: 0,
          resolvedCount: 0,
          totalInvoiceRevenue: 0,
        },
        "30days": {
          pendingDebt: 0,
          totalAmount: 0,
          totalRecovered: 0,
          resolvedCount: 0,
          totalInvoiceRevenue: 0,
        },
        "12months": {
          pendingDebt: 0,
          totalAmount: 0,
          totalRecovered: 0,
          resolvedCount: 0,
          totalInvoiceRevenue: 0,
        },
      };
    }
  },
};
